import { Component, OnInit, Input } from '@angular/core';
import { IBreadcrumb } from '../models/breadcrumb';

@Component({
  selector: 'ngx-header',
  templateUrl: './ngx-header.component.html',
  styleUrls: ['./ngx-header.component.scss']
})
export class NgxHeaderComponent implements OnInit {

  // header
  @Input() header: string;
  // breadcrumbs
  @Input() breadcrumbs: IBreadcrumb[] = [];

  constructor() { }

  ngOnInit(): void { }

}
